import { useCallback, useEffect, useState } from "react";

export default function UseLocation() {
  const [coordinates, setCoordinates] = useState(undefined);

  const [, setWatchId] = useState();
  const setPosition = useCallback((position, granted) => {
    if (
      granted &&
      position &&
      position.coords.latitude &&
      position.coords.longitude
    ) {
      setCoordinates([position.coords.longitude, position.coords.latitude]);
    } else {
      setCoordinates(undefined);
    }
  }, []);

  const setWatchPosition = useCallback(
    (granted) => {
      if (navigator.geolocation) {
        if (!granted) {
          navigator.geolocation.watchPosition(() => {});
          setCoordinates(undefined);
        } else {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setPosition(position, granted);
            },
            undefined,
            {
              enableHighAccuracy: true,
              maximumAge: 5000,
            }
          );

          const wid = navigator.geolocation.watchPosition(
            (position) => {
              setPosition(position, granted);
            },
            undefined,
            {
              enableHighAccuracy: true,
              maximumAge: 5000,
            }
          );

          setWatchId((oldwid) => {
            oldwid && navigator.geolocation.clearWatch(oldwid);
            return wid;
          });
        }
      }
    },
    [setPosition]
  );

  useEffect(() => {
    setWatchPosition(true);
  }, []);

  const changeStatePlatformDependant = useCallback(
    (permState) => {
      let granted = false;
      if (
        window.navigator.userAgent.toUpperCase().includes("MAC") ||
        window.navigator.userAgent.toUpperCase().includes("IPHONE")
      ) {
        granted = permState === "granted" || permState === "prompt";
      } else {
        granted = permState === "granted";
      }
      setWatchPosition(granted);
    },
    [setWatchPosition]
  );

  useEffect(() => {
    if (navigator.permissions) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permission) => {
          changeStatePlatformDependant(permission.state);
          permission.onchange = (e) => {
            changeStatePlatformDependant(permission.state);
          };
        });
    } else {
      changeStatePlatformDependant("granted");
    }
  }, [changeStatePlatformDependant]);

  return { coordinates };
}
